/**
 * Logger utility for consistent logging across the application
 * Replaces console.log/error/warn with environment-aware logging
 */

const isDevelopment = process.env.NODE_ENV === "development";

const logger = {
  /**
   * Debug logs - only shown in development
   * @param {...any} args - Arguments to log
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.log("[DEBUG]", ...args);
    }
  },

  /**
   * Info logs - shown in all environments
   * @param {...any} args - Arguments to log
   */
  info: (...args) => {
    console.log("[INFO]", ...args);
  },

  /**
   * Warning logs - shown in all environments
   * @param {...any} args - Arguments to log
   */
  warn: (...args) => {
    console.warn("[WARN]", ...args);
  },

  /**
   * Error logs - shown in all environments
   * @param {...any} args - Arguments to log
   */
  error: (...args) => {
    console.error("[ERROR]", ...args);
  },

  /**
   * Log API responses (only in development)
   * @param {string} endpoint - API endpoint
   * @param {any} data - Response data
   */
  apiResponse: (endpoint, data) => {
    if (isDevelopment) {
      console.log(`[API Response] ${endpoint}:`, data);
    }
  },

  /**
   * Log API errors
   * @param {string} endpoint - API endpoint
   * @param {Error} error - Error object
   */
  apiError: (endpoint, error) => {
    console.error(`[API Error] ${endpoint}:`, {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
  },
};

export default logger;
